import React, {Component} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter, Table, Button, Alert, Input} from 'reactstrap';
import {Switch} from "../../buttons/Swtich";
import {AgencyClientSelect, SPECIAL_ITEM_CREATE_AGENCY_CLIENT} from "../../selects/AgencyClientSelect";
import {ChannelLogo} from "../../channels/ChannelLogo";
import {APIClient} from "../../../utils/APIClient";
import {API_URL} from "../../../settings/local_settings";
import {AddClientModal} from "../../agency/AddClientModal";
import {Spinner} from "../../Spinner";
import { withTranslation } from 'react-i18next';


class CreateControlLinesModalComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            accountsData: [],
            showFormValidationTexts: false,
            errorText: null,
            allAgencyClients: null,
            searchTerm: "",
            creatingClientForAccountId: null,
            isSaving: false,
        };
        this.handleSwitchChange = this.handleSwitchChange.bind(this);
        this.handleClientChange = this.handleClientChange.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.fetchAgencyClients = this.fetchAgencyClients.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleClientAdded = this.handleClientAdded.bind(this);
        this.resetState = this.resetState.bind(this);
    }

    setIsSaving(new_value, callback) {
        this.setState({
            ...this.state,
            'isSaving': new_value
        }, callback);
    }
    
    resetState() {
        const accountsData = this.props.adAccounts.map(account => ({
            ...account,
            createLine: false,
            selectedClient: null,
        }));
        this.setState({
            accountsData: accountsData,
            showFormValidationTexts: false,
            errorText: null,
            searchTerm: "",
            creatingClientForAccountId: null,
            isSaving: false,
        });
    }
    
    handleClientAdded(newClientId, newClientName) {
        const newClient = {id: newClientId, name: newClientName, active: true};
        this.setState(prevState => ({
            allAgencyClients: [...prevState.allAgencyClients, newClient],
            accountsData: prevState.accountsData.map(account =>
                account.account_id === prevState.creatingClientForAccountId
                    ? {...account, selectedClient: newClient.id}
                    : account
            ),
        }));
    }

    componentDidMount() {
        const accountsData = this.props.adAccounts.map(account => ({
            ...account,
            createLine: false,
            selectedClient: null,
        }));
        this.setState({accountsData});
        this.fetchAgencyClients();
    }

    componentDidUpdate(prevProps) {
        if (this.props.adAccounts !== prevProps.adAccounts) {
            const accountsData = this.props.adAccounts.map(account => ({
                ...account,
                createLine: false,
                selectedClient: null,
            }));
            this.setState({accountsData});
        }
    }

    fetchAgencyClients() {
        new APIClient(API_URL + 'agency/clients/').call('GET').then((data) => {
            this.setState({allAgencyClients: data.data});
        });
    }

    handleSearchChange(event) {
        this.setState({searchTerm: event.target.value});
    }

    handleSwitchChange(accountId) {
        this.setState(prevState => ({
            accountsData: prevState.accountsData.map(account =>
                account.account_id === accountId ? {...account, createLine: !account.createLine} : account
            ),
        }));
    }

    handleClientChange(accountId, selectedAgencyClientId, selectedAgencyClientName) {
        if (selectedAgencyClientId === SPECIAL_ITEM_CREATE_AGENCY_CLIENT) {
            this.setState({creatingClientForAccountId: accountId}, () => {
                this.addClientModal.toggle();
            });
        } else {
            this.setState(prevState => ({
                accountsData: prevState.accountsData.map(account =>
                    account.account_id === accountId ? {...account, selectedClient: selectedAgencyClientId} : account
                ),
            }));
        }
    }

    handleCreate() {
        this.setState({showFormValidationTexts: true, errorText: null});

        const accountsToCreate = this.state.accountsData.filter(a => a.createLine);
        if (accountsToCreate.some(a => !a.selectedClient)) {
            const { t } = this.props;
            this.setState({errorText: t('create_control_lines_modal.must_assign_client_for_each_selected_account')});
            return;
        }

        const dataToPost = accountsToCreate.map(a => ({
                "channel": a.channel,
                "account_id": a.account_id,
                "agency_client_id": a.selectedClient
        }));
        
        if (accountsToCreate.length > 0) {
            this.setIsSaving(true, () => {
                new APIClient(API_URL + 'business-unit/add-bulk').call('POST', dataToPost).then((data) => {
                    this.setIsSaving(false, () => {
                        if (data.status === "OK") {
                            this.props.onFinish(data.data.business_units_created_count);
                        } else {
                            const { t } = this.props;
                            this.setState({errorText: data.error_message || t('create_control_lines_modal.error_occurred')})
                        }
                    });
                });
            });
        } else {
            this.props.onFinish(0);
        }
    }

    renderAccountColumnText(clientAdAccount) {
        return (
            <div style={{minWidth: "200px", paddingTop: "10px", paddingBottom: "10px"}}>
                <span style={{float: "left", paddingLeft: '0'}}>
                    <ChannelLogo useOld={false} width="20px" height={"20px"} channel={clientAdAccount.channel} marginLeft={"5px"}/>
                </span>
                <span style={{float: "left", paddingLeft: '0'}}>
                    {clientAdAccount.account_id}<br/>{clientAdAccount.name}
                </span>
            </div>
        )
    }

    render() {
        const { t } = this.props;
        const anySwitchOn = this.state.accountsData.some(a => a.createLine);
        const buttonText = this.state.isSaving ? <Spinner color="positive small"/> : (anySwitchOn ? t('create_control_lines_modal.create') : t('create_control_lines_modal.dont_create_now'));

        const filteredAccounts = this.state.accountsData
            .filter(account => {
                const searchTerm = this.state.searchTerm.toLowerCase();
                return account.name.toLowerCase().includes(searchTerm) || account.account_id.toLowerCase().includes(searchTerm);
            })
            .sort((a, b) => {
                // Sort checked accounts first, then unchecked accounts
                if (a.createLine && !b.createLine) return -1;
                if (!a.createLine && b.createLine) return 1;
                return 0;
            });

        return (
            <React.Fragment>
                <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} size="xl" className='control-lines-modal' backdrop="static" onClosed={this.resetState}>
                    <ModalHeader toggle={this.props.toggle}>
                        {t('create_control_lines_modal.want_to_create_control_lines_automatically')}
                    </ModalHeader>
                    <ModalBody style={{padding: '2rem'}}>
                        <p>
                            {t('create_control_lines_modal.select_accounts_for_monthly_control_line')}
                        </p>
                        <p style={{fontWeight: 'bold'}}>
                            {t('create_control_lines_modal.can_skip_step_and_create_later')}
                        </p>
                        {this.state.errorText && <Alert color="danger">{this.state.errorText}</Alert>}
                        <Input
                            type="text"
                            placeholder={t('create_control_lines.search_placeholder')}
                            value={this.state.searchTerm}
                            onChange={this.handleSearchChange}
                            style={{marginBottom: "10px"}}
                        />
                        <div style={{height: '400px', overflowY: 'auto'}}>
                            <div style={{position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1}}>
                                <Table>
                                    <thead>
                                    <tr>
                                        <th className='column-account'>{t('create_control_lines.account_column')}</th>
                                        <th className='column-create-line'>{t('create_control_lines.create_line_column')}</th>
                                        <th className='column-client-assigned'>{t('create_control_lines.client_assigned_column')}</th>
                                    </tr>
                                    </thead>
                                </Table>
                            </div>
                            <Table className='table-content table-striped'>
                                <tbody>
                                {filteredAccounts.map(account => (
                                    <tr key={account.account_id}>
                                        <td className='column-account'>{this.renderAccountColumnText(account)}</td>
                                        <td className='column-create-line'>
                                            <Switch
                                                checked={account.createLine}
                                                onChange={() => this.handleSwitchChange(account.account_id)}
                                            />
                                        </td>
                                        <td className='column-client-assigned'>
                                            {account.createLine &&
                                            <AgencyClientSelect
                                                allAgencyClients={this.state.allAgencyClients}
                                                selectedAgencyClient={account.selectedClient}
                                                onAgencyClientChange={(id, name) => this.handleClientChange(account.account_id, id, name)}
                                                canCreateNewAgencyClient={true}
                                                showFormValidationTexts={this.state.showFormValidationTexts && !account.selectedClient}
                                                hideGoToAgencyClientsAssignment={true}
                                            />}
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="dark" onClick={this.handleCreate}>{buttonText}</Button>
                    </ModalFooter>
                </Modal>
                <AddClientModal
                    showButton={false}
                    ref={instance => { this.addClientModal = instance; }}
                    onClientAdded={this.handleClientAdded}
                />
            </React.Fragment>
        );
    }
}

export const CreateControlLinesModal = withTranslation()(CreateControlLinesModalComponent);
